import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnboardingEventConfigEditPageUI from './OnboardingEventConfigEditPageUI'

class OnboardingEventConfigEditPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventDetails: null, // Will hold the form data
            loading: true,
            errorList: null,
            submitting: false,
            submitError: null,
            errors: {},
            isFormValid: true // Initially true as we load existing valid data usually
        }
    }

    componentDidMount() {
        this.getEventDetails()
        Modal.setAppElement('body')
    }

    getEventDetails = () => {
        let context = this.props.context
        let eventCode = this.props.match.params.eventCode

        if (eventCode) {
            RestApiUtils.get(context, `/api/notify-event-configurations/${eventCode}`, this.getEventDetailsCallback)
        } else {
            this.setState({ loading: false, errorList: [{ message: 'Invalid Event Code' }] })
        }
    }

    getEventDetailsCallback = (response) => {
        if (response && !response.errorList.length) {
            this.setState({ eventDetails: response.entity, loading: false }, () => {
                this.validateForm(response)
            })
        } else if (response.errorList) {
            this.setState({ errorList: response.errorList, loading: false })
        } else {
            this.setState({ loading: false, errorList: [{ message: 'Failed to load details' }] })
        }
    }

    validateField = (field, value, formState) => {
        let errors = { ...this.state.errors }
        let error = ''
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        switch (field) {
            case 'eventName':
                if (!value || (typeof value === 'string' && value.trim() === '')) {
                    error = 'Required'
                } else if (value.length < 5) {
                    error = 'Minimum 5 characters required'
                }
                break
            case 'messageBodyText':
                const isSpecialEventMsgEdit = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventMsgEdit) {
                    if (!value || (typeof value === 'string' && value.trim() === '')) {
                        error = 'Required'
                    } else if (value.length < 5) {
                        error = 'Minimum 5 characters required'
                    }
                }
                break
            case 'whatsappTemplateName':
                if (formState.eventCode !== 'PAN_AWAITED') {
                    if (!value || (typeof value === 'string' && value.trim() === '')) {
                        error = 'Required'
                    } else if (value.length < 5) {
                        error = 'Minimum 5 characters required'
                    }
                }
                break
            // eventCode is readOnly in Edit
            case 'whatsappFrequencyDays':
            case 'maxWhatsappCount':
                const isSpecialEventOrPan = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED' || formState.eventCode === 'PAN_AWAITED';
                if (!isSpecialEventOrPan) {
                    if (value === '' || value === null || value === undefined) {
                        error = 'Required'
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            case 'emailFrequencyDays':
            case 'maxEmailCount':
                const isSpecialEvent = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEvent) {
                    if (value === '' || value === null || value === undefined) {
                        error = 'Required'
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            case 'escalationAfterReminders':
                const isSpecialEventEsc = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventEsc && formState.escalationRequired) {
                    if (value === '' || value === null || value === undefined) {
                        error = 'Required'
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            case 'escalationEmail':
                const isSpecialEventEmail = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventEmail && formState.escalationRequired) {
                    if (!value || value.trim() === '') {
                        error = 'Required'
                    } else {
                        const emails = value.split(',').map(email => email.trim()).filter(email => email !== '');
                        const invalidEmails = emails.filter(email => !emailRegex.test(email));
                        if (invalidEmails.length > 0) {
                            error = 'One or more invalid email formats';
                        }
                    }
                }
                break
            case 'coolOffPeriodMin':
                const isSpecialEventCool = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventCool && formState.isActive) {
                    if (value === '' || value === null || value === undefined) {
                        error = 'Required'
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            default:
                break
        }

        if (error) {
            errors[field] = error
        } else {
            delete errors[field]
        }
        return errors
    }

    validateForm = (details) => {
        let isValid = true
        let errors = {}
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        // 1. Event Information
        if (!details.eventName || details.eventName.trim().length < 5) errors.eventName = details.eventName ? 'Min 5 chars' : 'Required'
        if (details.eventCode !== 'PAN_AWAITED') {
            if (!details.whatsappTemplateName || details.whatsappTemplateName.trim().length < 5) errors.whatsappTemplateName = details.whatsappTemplateName ? 'Min 5 chars' : 'Required'
        }

        if (!isSpecialEvent) {
            if (!details.messageBodyText || details.messageBodyText.trim().length < 5) errors.messageBodyText = details.messageBodyText ? 'Min 5 chars' : 'Required'
        }

        // 2. Notification Settings
        const isSpecialEvent = details.eventCode === 'WAITING_SCREEN' || details.eventCode === 'BANK_DATA_COLLECTED';
        const isPanAwaited = details.eventCode === 'PAN_AWAITED';

        if (!isSpecialEvent) {
            if (!isPanAwaited) {
                if (details.whatsappFrequencyDays === '' || details.whatsappFrequencyDays === null) errors.whatsappFrequencyDays = 'Required'
                if (details.maxWhatsappCount === '' || details.maxWhatsappCount === null) errors.maxWhatsappCount = 'Required'
            }
            if (details.emailFrequencyDays === '' || details.emailFrequencyDays === null) errors.emailFrequencyDays = 'Required'
            if (details.maxEmailCount === '' || details.maxEmailCount === null) errors.maxEmailCount = 'Required'

            // 3. Escalation Settings
            if (details.escalationRequired) {
                if (details.escalationAfterReminders === '' || details.escalationAfterReminders === null) errors.escalationAfterReminders = 'Required'
                if (!details.escalationEmail || details.escalationEmail.trim() === '') {
                    errors.escalationEmail = 'Required'
                } else {
                    const emails = details.escalationEmail.split(',').map(email => email.trim()).filter(email => email !== '');
                    const invalidEmails = emails.filter(email => !emailRegex.test(email));
                    if (invalidEmails.length > 0) {
                        errors.escalationEmail = 'Invalid format';
                    }
                }
            }

            // 4. Other Settings
            if (details.isActive) {
                if (details.coolOffPeriodMin === '' || details.coolOffPeriodMin === null) errors.coolOffPeriodMin = 'Required'
            }
        }

        if (Object.keys(errors).length > 0) isValid = false

        this.setState({ isFormValid: isValid })
        return isValid
    }

    handleInputChange = (field, value) => {
        let newDetails = {
            ...this.state.eventDetails,
            [field]: value
        }

        let errors = this.validateField(field, value, newDetails)

        this.setState({
            eventDetails: newDetails,
            errors: errors
        }, () => {
            this.validateForm(newDetails)
        })
    }

    handleSubmit = () => {
        this.setState({ submitting: true, submitError: null })
        let context = this.props.context
        let payload = { ...this.state.eventDetails }
        delete payload.sendInstantly

        RestApiUtils.put(context, '/api/notify-event-configurations', this.handleSubmitCallback, payload)
    }

    handleSubmitCallback = (response) => {
        if (response && response.success) { // Assuming success property or similar check
            this.setState({ submitting: false })
            this.props.history.push('/su/onboarding-events') // Navigate back to list on success
        } else if (response && response.errorList) {
            this.setState({ submitting: false, submitError: response.errorList[0].message })
        } else {
            // Fallback if success isn't explicitly returned or for other errors
            // Based on typical project patterns, if no errorList, it might be a success if it returns the object
            if (response && response.eventCode) {
                this.setState({ submitting: false })
                this.props.history.push('/su/onboarding-events')
            } else {
                this.setState({ submitting: false, submitError: 'Update failed. Please try again.' })
            }
        }
    }

    onCancel = () => {
        this.props.history.goBack()
    }

    render() {
        return (
            <OnboardingEventConfigEditPageUI
                context={this.props.context}
                eventDetails={this.state.eventDetails}
                loading={this.state.loading}
                errorList={this.state.errorList}
                submitting={this.state.submitting}
                submitError={this.state.submitError}
                onInputChange={this.handleInputChange}
                onSubmit={this.handleSubmit}
                onCancel={this.onCancel}
                errors={this.state.errors}
                isFormValid={this.state.isFormValid}
            />
        )
    }
}

export default withRouter(OnboardingEventConfigEditPageSF)
